var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertify-code"},[_c('img',{attrs:{"src":_vm.src,"alt":"点击刷新"},on:{"click":_vm.refreshCode}})])}
var staticRenderFns = []

export { render, staticRenderFns }